export default {
      id: "ic_meteo_maree-usage",
      viewBox: "0 0 20 20",
      url: "../dist/images/" + "sprite.svg#ic_meteo_maree-usage",
      toString: function () {
        return this.url;
      }
    }